/**
 * POS Products Sync Hook (SSE)
 *
 * SSE-based variant qui fournit une progression temps reel.
 * A utiliser a la place de usePosSync (mutation simple sans progress)
 * pour les sync qui peuvent durer plusieurs minutes (rate-limit Bill
 * 1 req/20s).
 */

import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useSSE } from '@/hooks';

interface PosSyncResult {
  success: boolean;
  status: string;
  duration: number;
  stats: {
    total: number;
    created: number;
    updated: number;
    unchanged: number;
    deleted: number;
    errors: number;
  };
}

export function usePosSyncStream() {
  const queryClient = useQueryClient();

  const { start, stop, progress, result, error, isLoading } = useSSE<PosSyncResult>(
    '/pos-products/sync/stream',
    {
      onDone: (syncResult) => {
        queryClient.invalidateQueries({ queryKey: ['pos-products'] });
        queryClient.invalidateQueries({ queryKey: ['pos-sync-status'] });

        if (syncResult.success) {
          toast.success(
            `Synchronisation reussie : ${syncResult.stats.created} crees, ${syncResult.stats.updated} mis a jour${syncResult.stats.deleted ? `, ${syncResult.stats.deleted} supprimes dans Bill` : ''}`
          );
        } else {
          toast.error('Synchronisation terminee avec des erreurs');
        }
      },
      onError: (errorMessage) => {
        toast.error(`Echec de la synchronisation : ${errorMessage}`);
      },
    }
  );

  return {
    startSync: () => start(),
    cancelSync: stop,
    progress,
    result,
    error,
    isLoading,
  };
}
